import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@mui/material';
const Explanation = ({ explanation }) => (_jsx(Typography, { sx: {
        color: '#007bad',
        ml: 4,
        pb: 1,
    }, children: explanation }));
export default Explanation;
//# sourceMappingURL=Explanation.js.map